'use client';

import { useContext } from 'react';

import { DataContext } from './context/data-context';

type ImmutableData = {
  firstTenant: { name: string };
  secondTenant: { name: string } | null;
  apartment: { address: string; deposit_sum: string; rental_date: string };
  lessor: { name: string; address: string };
};

function buildMailtoBody(immutableData?: ImmutableData): string {
  const lines: string[] = [
    'Sehr geehrte Damen und Herren,',
    '',
    'bei der Vervollständigung meines Antrags bei Aareal Aval ist mir ein Fehler in den Bestandsdaten aufgefallen.',
    '',
  ];

  if (immutableData) {
    lines.push('Meine Referenzdaten:');
    lines.push(`Name: ${immutableData.firstTenant.name}`);
    if (immutableData.secondTenant) {
      lines.push(`Zweiter Mieter: ${immutableData.secondTenant.name}`);
    }
    lines.push(`Adresse neue Wohnung: ${immutableData.apartment.address}`);
    lines.push(`Mietkaution: ${immutableData.apartment.deposit_sum}`);
    lines.push(`Beginn Mietvertrag: ${immutableData.apartment.rental_date}`);
    lines.push(`Vermieter: ${immutableData.lessor.name}`);
    lines.push(`Adresse des Vermieters: ${immutableData.lessor.address}`);
    lines.push('');
  }

  lines.push('Folgende Angabe ist fehlerhaft:');
  lines.push('');
  lines.push('');
  lines.push('Mit freundlichen Grüßen,');
  lines.push('');

  return lines.join('\r\n');
}

export default function MailtoButton() {
  const context = useContext(DataContext);
  const immutableData = context?.data?.immutableData;

  const subject = 'Fehler in meinen Bestandsdaten bei Aareal Aval';
  const body = buildMailtoBody(immutableData);
  const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <a href={mailtoLink} className="text-aareal-aval-light underline">
      E-Mail Vorlage
    </a>
  );
}
